import { RxStore } from './rxStore.js';
class GlobalRxStores {
    // eslint-disable-next-line
    constructor() {
        this.ReactiveXStoresByKey = new Map([
            ['default', GlobalRxStores.getDefaultStore()],
        ]);
    }
    static getInstance() {
        return this._instance;
    }
    static getDefaultStore() {
        return this._defaultStore;
    }
    /**
     * Retrieves BehaviorSubject from default store
     * @param subjectKey
     * @returns BehaviorSubject
     * @throws Will throw an error if subject does not exist in defaultStore
     */
    static getBehaviorSubject(subjectKey) {
        const behaviorSubject = this._defaultStore.behaviorSubjectsByKey.get(subjectKey);
        if (!behaviorSubject) {
            throw new Error(`Attempted to retrieve nonexistant subject: ${String(subjectKey)}`);
        }
        return behaviorSubject;
    }
}
GlobalRxStores._instance = new GlobalRxStores();
GlobalRxStores._defaultStore = new RxStore();
export { GlobalRxStores };
//# sourceMappingURL=globalRxStores.js.map